import AppToast from "@toothfairy/shared-ui/AppToast";
import AppUser from "@toothfairy/shared-ui/AppUser";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import usersHelper from "../../API/Users/usersHelper";
import usePath from "../../Hooks/usePath";
import { SectionsProvider } from "../../Hooks/useSections";
import { useProfileMenuItems } from "../../Hooks/useSectionMenuItems";
import useWorkspaces from "../../Hooks/useWorkspaces";
import { useHistory } from "../../Router";
import AccountScreen from "./AccountScreen";
import { changeLanguage } from "../../../i18n.config";

const AccountScreenContainer = ({ setCurrentView }) => {
  const { t, i18n } = useTranslation();
  const AppToasty = AppToast.useToast();
  const history = useHistory();
  const { params } = usePath();
  const { user, updateUser } = AppUser.useUser();
  const { getLastTabSelectedByScreen, handleSectionSelection } =
    useWorkspaces();
  let _defaultView;
  if (params.sectionId) {
    _defaultView =
      params.sectionId?.toUpperCase() ||
      getLastTabSelectedByScreen("profile", "PROFILE");
  }
  const profileMenuItems = useProfileMenuItems();
  const optionsDataGenerator = useCallback(
    () => profileMenuItems,
    [profileMenuItems]
  );

  const handleUserUpdate = (property, value) => {
    try {
      if (user[property] !== value) {
        usersHelper.updateUser(user?.id, [
          {
            property,
            value,
          },
        ]);
        updateUser({ ...user, [property]: value });
        if (property === "language" && value) changeLanguage(value);
        // #332 to do
        AppToasty.show(
          property === "userInstructions"
            ? t("profile.instructionsUpdated")
            : t("profile.settingUpdated"),
          {
            type: "success",
          }
        );
      }
    } catch (error) {
      AppToasty.show(
        property === "userInstructions"
          ? t("profile.instructionsUpdateFailed")
          : t("profile.settingUpdateFailed"),
        { type: "danger" }
      );
      console.error("Error while updating profile", error);
    }
  };

  return _defaultView ? (
    <SectionsProvider
      defaultViewUID={_defaultView}
      onDisplayedViewChanged={(section) => {
        handleSectionSelection(section, "profile");
        if (section) {
          const target = `/profile/${section.toLowerCase()}`;
          if (history.location?.pathname !== target) history.push(target);
        }
      }}
      sectionsMainTitle="Profile"
      optionsDataGenerator={optionsDataGenerator}
    >
      <AccountScreen
        setCurrentView={setCurrentView}
        handleUserUpdate={handleUserUpdate}
      />
    </SectionsProvider>
  ) : (
    <></>
  );
};

export default AccountScreenContainer;
